<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Операция с членством,  пакетом услуг</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен / Рабочий стол /</span> Операция с членством,  пакетом услуг</div>
                </div>
              </v-col>
              <v-col cols="12" v-if="error.dialog">
                <v-alert
                  border="left"
                  color="red"
                  dense
                  dismissible
                  type="error"
                >
                  {{ error.message }}
                </v-alert>
              </v-col>
              <v-col>
                <v-form ref="addClientForm" @submit.prevent="submitFreezeStatus">
                <v-sheet class="card rounded-lg" style="padding: 0 !important;">
                  <div class="column" style="padding: 20px 20px 0 20px !important;">
                    <v-row>
                      <v-col
                          md="6"
                          sm="12"
                      >
                        <label>Клиент</label>
                        <div class="d-flex" style="align-items: center">
                          {{ visitorDesktop.client.name}}
                        </div>
                      </v-col>
                      <v-col
                          md="6"
                          sm="12"
                      >
                        <label>Операция</label>
                        <v-select
                            class="rounded-lg custom__select"
                            :items="operations"
                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                            item-text="name"
                            item-value="link"
                            v-model="operation"
                            label="Выбрать"
                            append-icon="mdi-chevron-down"
                            :background-color="getBgColor(operation)"
                            color="#629f34"
                            outlined
                            dense
                            required
                            style="height: 48px;margin-top: 5px; margin-bottom: 0 !important;"
                        >
                          <template v-slot:item=" { item } ">
                            <router-link :to="{ name: item.link, params: {client_id: client_id, product_id: product_id}}" style="text-decoration: none; color: #000">
                              {{ item.name }}
                            </router-link>
                          </template>
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                          md="6"
                          sm="12"
                      >
                        <label>Членство, пакет услуг</label>
                        <v-select
                            v-if="visitorDesktop"
                            :items="visitorDesktop.client.productes"
                            item-value="product_id"
                            item-text="product_name"
                            v-model="product_id"
                            class="rounded-lg"
                            append-icon="mdi-chevron-down"
                            hide-details
                            outlined
                            dense
                            background-color="white"
                            style="height: 48px;padding-top: 5px; flex: none !important;"
                        >
                        </v-select>
                      </v-col>
                      <v-col
                          md="2"
                          sm="12"
                      >
                        <label>С</label>
                        <VueDatePicker
                            no-title
                            no-header
                            color="#629f34"
                            v-model="dateFrom"
                            placeholder="Дата"
                        >
                          <template #activator="{ date }">
                            <button
                                class="button custom__datepicker"
                                ref="activator"
                                type="button"
                            >
                              <div>
                                <span v-if="dateFrom">{{ date }}</span>
                                <span v-else style="color: gray">Дата</span>
                              </div>
                              <div>
                                <v-icon
                                    medium
                                    right
                                    class="ml-5"
                                >
                                  mdi-calendar-blank-outline
                                </v-icon>
                              </div>
                            </button>
                          </template>
                        </VueDatePicker>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                          md="6"
                          style="padding: 0 16px 20px 16px !important;"
                      >
                        <div class="hint">
                          Использовано заморозок на: {{freezeList.data.data.used || 0}} дней. Доступно заморозок на: {{freezeList.data.data.balance || 0}} дня. Минимальный срок: {{freezeList.data.data.minimum || 0}} дней.
                        </div>
                      </v-col>
                      <v-col
                          md="6"
                          style="padding: 0 16px 20px 16px !important;"
                      >
                        <div class="hint">
                          Используется для временного прекращения действия членства (пакеты услуг). Срок
                          действия членства (пакеты услуг) увеличивается на срок заморозки.
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                  <div class="column">
                    <v-data-table
                        v-model="selectProduct"
                        :headers="headersProductes"
                        :items="freezeList.data.data.documents"
                        :hide-default-footer="true"
                        no-data-text="Нет членства (пакеты услуг)"
                        item-key="name"
                        class="elevation-1 mt-3 rounded-b-0 custom__table"
                    >


                    </v-data-table>
                  </div>
                  <div class="column d-flex justify-space-between" style="padding: 20px !important;">
                    <div>

                      <v-btn
                          :to="{ name: 'SaleHistory', params: {client_id: client_id} }"
                          class="button__lighten ml-3"
                      >
                        <img src="/playground_assets/clock-logo.svg" class="mr-1" alt="">
                        История
                      </v-btn>
                    </div>
                    <div>
                      <v-btn :disabled="isLoading" class="button__success" type="submit">
                        Разморозить
                      </v-btn>
                    </div>
                  </div>
                </v-sheet>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import {clientActionTypes} from '@/store/modules/client';
import {receptionActionTypes} from '@/store/modules/reception';
import {mapState} from "vuex";
import {getItem, setItem} from "../helpers/persistanceStorage";
export default {
  name: "UnfreezePackage",
  props: ['client_id','product_id'],
  components: {
    Header,
    Menu,
    VueDatePicker
  },
  computed: {
    ...mapState({
      isLoading: state => state.client.isLoading,
      visitorDesktop: state => state.reception.visitorDesktop,
      freezeList: state => state.client.freezeList,
    }),
    searchPackages() {
      return this.visitorDesktop.client.productes.filter((i) => {
        return !this.searchPackages || (i.name.toLowerCase().includes(this.searchPackages.toLowerCase()));
      })
    }
  },
  data () {
    return {
      search: '',
      searchPackage: '',
      dateFrom:  new Date().toISOString().slice(0, 10),
      dateTo: null,
      selectProduct: null,
      days: null,
      operations: [
        {name: 'Заморозка', link: 'FreezePackage'},
        {name: 'Разморозка', link: 'UnfreezePackage'},
        {name: 'Смена владельца', link: 'ChangeOwner'},
      ],
      operation: 'UnfreezePackage',
      headersProductes: [
        {text: 'Дата', value: 'date'},
        {text: 'Документы', value: 'document.name'},
        {text: 'Дата c', value: 'startdate'},
        {text: 'Дата до', value: 'enddate'},
        {text: 'Дней', value: 'days'},
      ],
      name:null,
      daysRules: [
        v => !!v || 'Кол-во дней обязательное поле'
      ],
      dateFromRules: [
        v => !!v || 'Дата начала обязательное поле'
      ],
      error: {
        dialog: false,
        message: ''
      }
    }
  },
  methods: {
    submitFreezeStatus() {
      if (this.$refs.addClientForm.validate()) {
        this.$store.dispatch(clientActionTypes.setUnFreezeStatus, {
          client_id: this.client_id,
          product_id: this.product_id,
          date: this.dateFrom

        })
            .then((response) => {
              if (!response.success && response.error) {
                this.error.dialog = response.error;
                this.error.message = response.message;
              }
              this.fetchFeed(this.client_id,this.product_id);
            })
      }
    },
    fetchFeed(client_id,product_id) {
      this.$store.dispatch(receptionActionTypes.desktopClient, {client_id})
      this.$store.dispatch(clientActionTypes.getFreezeList,{client_id: client_id,product_id: product_id});
    },
    getBgColor(operation) {
      if (operation === 'FreezePackage') {
        return '#FBEBEA';
      } else if (operation === 'UnfreezePackage') {
        return '#E0ECD6';
      } else {
        return '#FFF8E6';
      }
    }
  },
  mounted() {
    this.client_id !== undefined ? setItem('unfreeze-client_id', this.client_id) : this.client_id = getItem('unfreeze-client_id');
    this.product_id !== undefined ? setItem('unfreeze-product_id', this.product_id) : this.product_id = getItem('unfreeze-product_id');
    this.fetchFeed(this.client_id,this.product_id);
  },
  watch: {
    days() {
      if (this.dateFrom !== null) {
        var someDate = new Date();
        var duration = this.days
        someDate.setTime(someDate.getTime() +  (duration * 24 * 60 * 60 * 1000))
        this.dateTo = someDate
      }
    },
    product_id(){
      this.fetchFeed(this.client_id,this.product_id);
    }
  },

}
</script>

<style scoped>
.vd-activator .custom__datepicker {
  width: 89% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: space-between !important;
  margin-top: 5px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}
.hint {
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #767676;
}
</style>